var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromoTag = function SvgPromoTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F55F00",
    d: "m14.854 9.563-5.291 5.29a.5.5 0 0 1-.707 0l-6.21-6.207a.5.5 0 0 1-.146-.353V2.5h5.793a.5.5 0 0 1 .353.146l6.208 6.208a.5.5 0 0 1 0 .709",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F55F00",
    d: "M15.207 8.5 9 2.293A1 1 0 0 0 8.293 2H2.5a.5.5 0 0 0-.5.5v5.793A1 1 0 0 0 2.293 9L8.5 15.207a1 1 0 0 0 1.414 0l5.293-5.293a1 1 0 0 0 0-1.414m-6 6L3 8.293V3h5.293L14.5 9.207zM6 5.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};
export default SvgPromoTag;